import { isIndianUser } from "./paymentCountry";
import { redirectToStripeCheckout } from "./stripeCheckout";

export const startServicePayment = async (
  service,
  country,
  { onIndianPayment }
) => {
  if (!service?._id) {
    throw new Error("Selected service is missing payment details.");
  }

  if (isIndianUser(country)) {
    onIndianPayment(service);
    return;
  }

  await redirectToStripeCheckout(service);
};
